import { apiClient } from 'modules/app/configs/axios';

const endpoint = '/notifications/register_token';

export const registerPushToken = async (token: string, deviceType: string = 'web') => {
  try {
    const response = await apiClient.post(endpoint, {
      token,
      device_type: deviceType,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};